/** @jsxImportSource @emotion/react */
import { Layout, Video } from '@ssmm/ui';
import { modList, videoList } from 'components/landing/settings';

import { Modal } from '../../ui';
import Info from '../s4/components/info';
import Controls from '../s4/components/module-select';

const VideoGallery = ({ onClose, selectModule, currentModuleId }) => (
  <Modal
    title="Видео обзор"
    onClose={onClose}
    getContainer={() => document.getElementById('root')}
    width={980}
  >
    <div
      css={{
        padding: `30px 10px 35px 30px`,
        display: 'flex',
        alignItems: 'stretch',
        flexDirection: 'row',
        overflow: 'hidden',
        div: {
          display: 'flex',
        },
        '>div': {
          flexDirection: 'column',
        },
      }}
    >
      <div css={{ flex: '1 5 608px' }}>
        <Video
          video={videoList[currentModuleId].video}
          autoplay
          css={{ marginBottom: 30 }}
          title={modList[currentModuleId].title}
        />

        <Info currentModuleId={currentModuleId} css={{ marginBottom: 30 }} />

        <Controls currentModuleId={currentModuleId} selectModule={selectModule} />
      </div>
      <div css={{ flex: '0 2 312px', marginLeft: 20, flexDirection: 'column' }}>
        <Layout
          direction="column"
          scroll
          paddingRight={20}
          paddingLeft={10}
          css={{ paddingBottom: 20, '>*:not(:last-of-type)': { marginBottom: 15 } }}
        >
          {Object.keys(modList)
            .filter(m => m !== currentModuleId)
            .map(m => (
              <Video
                key={m}
                video={videoList[m].cover}
                controls={false}
                css={{ cursor: 'pointer', filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))' }}
                onClick={() => selectModule(m)}
              />
            ))}
        </Layout>
      </div>
    </div>
  </Modal>
);

export default VideoGallery;
